module.exports = __webpack_public_path__ + "img/wx.a7353ebf.png";